// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.
// frontend/src/design-system/components/data-display/Metric.jsx

import React from "react";

function joinClassNames(...values) {
  return values.filter(Boolean).join(" ");
}

function displayValue(value, fallback = "—") {
  if (value === null || value === undefined || value === "") return fallback;

  if (
    typeof value === "string" ||
    typeof value === "number" ||
    typeof value === "boolean"
  ) {
    return String(value);
  }

  return fallback;
}

export default function Metric({
  label,
  value,
  supportingText,
  trend,
  tone = "neutral",
  size = "default",
  presentation = "inline",
  className = "",
}) {
  return (
    <div
      className={joinClassNames(
        "oasys-metric",
        `oasys-metric--${size}`,
        `oasys-metric--${presentation}`,
        `oasys-metric--${tone}`,
        className
      )}
    >
      <span className="oasys-metric__label">
        {displayValue(label, "Metric")}
      </span>

      <strong className="oasys-metric__value">
        {displayValue(value)}
      </strong>

      {trend || supportingText ? (
        <div className="oasys-metric__supporting">
          {trend ? (
            <span className="oasys-metric__trend">
              {displayValue(trend, "")}
            </span>
          ) : null}

          {supportingText ? (
            <span>{displayValue(supportingText, "")}</span>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
